export default "__VITE_ASSET__Vb9HRO88__"